export function SurveyModel(dict) {
    this.id = dict.id;
    this.incorrect_limit = dict.incorrect_limit;

    this.listPages = [];
    if (dict.pages && dict.pages instanceof Array) {
        for (var i=0; i<dict.pages.length; i++) {
            this.listPages.push(new SurveyPageModel(dict.pages[i]));
        }
    }
}

export function SurveyPageModel(dict) {
    var i, item, randomPos, anObject;
    this.answer = dict.answer;
    this.force_correct_answer = dict.force_correct_answer;
    this.html_question = dict.html_question;
    this.order_by = dict.order_by;
    this.page_number = dict.pageNumber;
    this.title = dict.title;
    this.type = dict.type;
    this.min_answer = dict.min_answer;
    this.max_answer = dict.max_answer;

    this.hashtags = [];
    if (dict.hashtags) {
        for (i=0; i<dict.hashtags.length; i++) {
            var valueTag = dict.hashtags[i];
            if (valueTag) {
                this.hashtags.push(valueTag);
            }
        }
    }

    this.listStringFields = [];
    if (dict.fields) {
        for (i=0; i<dict.fields.length; i++) {
            var valueField = dict.fields[i];
            if (valueField) {
                this.listStringFields.push(valueField);
            }
        }
    }

    this.listStringFieldsCode = [];
    if (dict.fields_code) {
        for (i=0; i<dict.fields_code.length; i++) {
            var valueFieldCode = dict.fields_code[i];
            if (valueFieldCode) {
                this.listStringFieldsCode.push(valueFieldCode);
            }
        }
    }

    this.listInputs = [];
    if (dict.inputs && dict.inputs instanceof Array) {
        var tmpArray = [];
        if (this.order_by) {
            // ถ้า order_by เป็น shuffle ต้องสลับตำแหน่งข้อมูลใน array ทุกครั้ง
            if (this.order_by == "shuffle") {
                for (i=0; i<dict.inputs.length; i++) {
                    anObject = dict.inputs[i];
                    randomPos = Math.random() % (tmpArray.length + 1);

                    //ถ้าเป็น type พวก other ข้อสุดท้ายที่เป็น textfield สุ่มแบบไหนก็ต้องอยู่ด้านล่าง
                    if((this.type == "info_choice_with_others"
                        || this.type == "info_check_box_with_others")
                        && i == (dict.inputs.length - 1))
                    {
                        tmpArray.push(anObject);
                    }else{
                        tmpArray.insert(anObject, randomPos);
                    }
                }
            } else if (this.order_by == "select") {
                // ถ้า order_by เป็น select จะสลับตำแหน่งเฉพาะข้อที่เลือกเท่านั้น
                var arrSelect = [];
                var arrIndex = [];

                // วนลูปเพื่อหาข้อมูลที่จะมาทำการ random
                for (i=0; i<dict.inputs.length; i++) {
                    item = dict.inputs[i];
                    var random_choice = item.random_choice;
                    if (random_choice) {
                        // ตัวที่ random จะเก็บไว้อีก list นึงเพื่อทำการ random
                        // และเก็บ index ของตัว list ที่จะสลับไว้ด้วย
                        if (random_choice == true)
                        {
                            arrSelect.push(item);
                            arrIndex.push(i);
                        }else{
                            // ตัวที่ไม่ random จะทำการเก็บข้อมูลตามปกติ
                            tmpArray.push(item);
                        }
                    }
                }

                // Random ค่าจาก list ที่ได้สั่งให้ random
                var randomArray = [];
                for (i=0; i<arrSelect.length; i++) {
                    anObject = arrSelect[i];
                    randomPos = Math.random() % randomArray.length + 1;

                    randomArray.insert(anObject, randomPos);
                }

                // วนลูป Index เพื่อต้องการเอาค่าที่ได้ทำการ random มาใส่กลับเข้าไป
                for (i=0; i<arrIndex.length; i++) {
                    var intIndex = arrIndex[i];

                    item = randomArray[0];
                    randomArray.slice(0, randomArray.length);
                    tmpArray.insert(item, intIndex);
                }
            } else if(this.order_by == "index_desc") {
                tmpArray = dict.inputs.reverse;

                //ถ้าเป็น type พวก other ข้อสุดท้ายที่เป็น textfield สุ่มแบบไหนก็ต้องอยู่ด้านล่าง
                if((this.type == "info_choice_with_others"
                    || this.type == "info_check_box_with_others")
                    && tmpArray.length > 0)
                {
                    item = tmpArray[0];
                    tmpArray.slice(0, tmpArray.length);
                    tmpArray.append(item);
                }
            }else{
                tmpArray = dict.inputs;
            }
        } else {
                tmpArray = dict.inputs;
        }

        for (i=0; i<tmpArray.length; i++) {
            this.listInputs.push(new SurveyInputModel(tmpArray[i]));
        }
    }
}

export function SurveyInputModel(dict) {
    this.answer = dict.answer;
    this.can_edit = dict.can_edit;
    this.index = dict.index;
    this.caption = dict.caption;
    this.call_number = dict.call_number;
    this.max_length = dict.max_length;
    this.image_url = dict.image_url;
    this.type = dict.type;
    this.code = dict.code;
    this.directChoice = dict.direct_choice;
    this.min_length = dict.min_length;
    this.random_choice = dict.random_choice;
    this.required = dict.required;
}

export function SurveyActionModel(dict) {
    this.and_link = dict.and_link;
    this.and_ns = dict.and_ns;

    if (dict.back_button) {
        this.back_button = dict.back_button;
    } else {
        this.back_button = false;
    }

    this.campaign_id = dict.campaign_id;

    // เป็นตัวบอกว่าได้ทำ survey จบแล้ว
    this.finishSurvey = false;

    this.install_agency = dict.install_agency;
    this.ios_itunes = dict.ios_itunes;
    this.ios_link = dict.ios_link;
    this.ios_schema = dict.ios_schema;
    this.link = dict.link;

    if (dict.page_percentage) {
        this.page_percentage = dict.page_percentage;
    } else {
        this.page_percentage = false;
    }

    if (dict.showserial) {
        this.showserial = dict.showserial;
    } else {
        this.showserial = false;
    }

    this.type = dict.type;
    this.typeads = dict.typeads;
    this.typeinstall = dict.typeinstall;
    this.verify_type = dict.verify_type;
}

export function SurveyAdsModel(dict) {
    this.orientation = dict.orientation;
    this.type = dict.type;
    this.items = [];

    if (dict.items && dict.items instanceof Array) {
        for (var i=0; i<dict.items.length; i++) {
            this.items.push(new SurveyAdsMediaModel(dict.items[i]));
        }
    }
}

export function SurveyAdsMediaModel(dict) {
    this.caption = dict.caption;
    this.content_type = dict.content_type;
    this.quality = dict.quality;
    this.size = dict.size;
    this.src = dict.src;
}

export function SurveyVideoMediaModel(dict) {
    this.andriod_suffix = dict.andriod_suffix;
    this.id = dict.id;
    this.web_suffix = dict.web_suffix;
    this.filename = dict.filename;
    this.type = dict.type;
    this.ios_suffix = dict.ios_suffix;
    this.url = dict.url;
}

// export {
//     SurveyModel, SurveyPageModel, SurveyInputModel, SurveyAdsModel, SurveyActionModel, SurveyAdsMediaModel, SurveyVideoMediaModel
// }
